import React from 'react';
import { FaTrashAlt, FaPenSquare, FaChartLine } from 'react-icons/fa';
import {
  EditButton,
  DeleteButton,
  ViewPaymentsButton,
} from '../styles/ComponentStyles';
import {
  BillsTableWrapper,
  BillsTableEl,
  BillsTableHeader,
  BillsTableRow,
  BillsTableData,
  TypeBadge,
  StatusBadgeBills,
} from '../styles/BillsTableStyles';
import PaginationControl from './PaginationControl';
import { gainLossColor, formatMoney, formatPct } from '../utils/investmentMath';

const InvestmentsTable = ({
  investments = [],
  loading,
  error,
  handleDelete,
  currentPage,
  currentPageLimit = 100,
  totalPages = 1,
  onPageChange,
  onPageLimitChange,
  onEdit,
  onViewDetail,
}) => {
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading investments.</div>;

  const typeLabel = (inv) =>
    inv.investment_type === 'Other' && inv.custom_type
      ? inv.custom_type
      : inv.investment_type || '—';

  return (
    <BillsTableWrapper>
      <h2>Investments</h2>
      <BillsTableEl>
        <thead>
          <tr>
            <BillsTableHeader>Name</BillsTableHeader>
            <BillsTableHeader>Type</BillsTableHeader>
            <BillsTableHeader>Platform</BillsTableHeader>
            <BillsTableHeader>Total Contributed</BillsTableHeader>
            <BillsTableHeader>Latest Value</BillsTableHeader>
            <BillsTableHeader>Gain / Loss</BillsTableHeader>
            <BillsTableHeader>Remarks</BillsTableHeader>
            <BillsTableHeader>Actions</BillsTableHeader>
          </tr>
        </thead>
        <tbody>
          {investments.map((inv) => (
            <BillsTableRow key={inv._id}>
              <BillsTableData>{inv.name || '—'}</BillsTableData>
              <BillsTableData>
                <TypeBadge $variant="subscription">{typeLabel(inv)}</TypeBadge>
              </BillsTableData>
              <BillsTableData>{inv.platform || '—'}</BillsTableData>
              <BillsTableData>{formatMoney(inv.total_contributed)}</BillsTableData>
              <BillsTableData>
                {inv.latest_value != null ? formatMoney(inv.latest_value) : '—'}
              </BillsTableData>
              <BillsTableData>
                {inv.gain_loss != null ? (
                  <StatusBadgeBills $color={gainLossColor(inv.gain_loss)}>
                    {inv.gain_loss >= 0 ? '+' : ''}
                    {formatMoney(inv.gain_loss)}
                    {inv.gain_loss_pct != null ? ` (${formatPct(inv.gain_loss_pct)})` : ''}
                  </StatusBadgeBills>
                ) : (
                  <StatusBadgeBills $color={gainLossColor(null)}>NO VALUE YET</StatusBadgeBills>
                )}
              </BillsTableData>
              <BillsTableData>{inv.remarks || '—'}</BillsTableData>
              <BillsTableData>
                {onViewDetail && (
                  <ViewPaymentsButton onClick={() => onViewDetail(inv)} title="Details">
                    <FaChartLine />
                  </ViewPaymentsButton>
                )}
                <EditButton onClick={() => onEdit(inv)} title="Edit">
                  <FaPenSquare />
                </EditButton>
                <DeleteButton onClick={() => handleDelete(inv._id)} title="Delete">
                  <FaTrashAlt />
                </DeleteButton>
              </BillsTableData>
            </BillsTableRow>
          ))}
          {investments.length === 0 && (
            <tr>
              <td colSpan={8} style={{ padding: 16, color: '#888' }}>
                No investments yet. Add one to start tracking gain/loss.
              </td>
            </tr>
          )}
        </tbody>
      </BillsTableEl>

      <PaginationControl
        currentPage={currentPage}
        currentPageLimit={currentPageLimit}
        totalPages={totalPages}
        handlePageChange={onPageChange}
        handlePageLimitChange={onPageLimitChange}
      />
    </BillsTableWrapper>
  );
};

export default InvestmentsTable;
